import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  Link as MuiLink,
  CardContent,
  Grid,
  Switch,
  Divider,
  Button,
  Chip,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditIcon from "@material-ui/icons/Edit";
import HttpsIcon from "@material-ui/icons/Https";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAppSelector } from "src/app-redux/hooks";
import {
  addUserRoleAction,
  updateUserRoleAction,
  getRolesListingAction,
} from "src/app-redux/management/actions/managementActions";
import { loading, selectRolesListing } from "src/app-redux/management/managementSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { ManagementRoute } from "../../../../management.routes";
import { columns } from "./columns";
import { useStyles } from "./style";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Check, Close } from "@material-ui/icons";
import { Tooltip } from "@mui/material";
import MultiSelect2 from "src/components/molecules/MultiSelect2";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function ListRoles({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = ManagementRoute.title;
  const pageHeading = "List of Roles";
  const dispatch = useDispatch();
  const [isEditMode, setisEditMode] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [consignmentType, setconsignmentType] = React.useState<any>([]);
  const [selctedConsignment, setSelctedConsignment] = React.useState<any>([]);
  const multiselectRef: any = useRef();
  const [loader1, setLoader1] = useState(false);
  const [allTerminal, setAllTerminal] = React.useState<any>([]);
  const [terminalId, setTerminalId] = React.useState<number>();

  const listRoles = useAppSelector(selectRolesListing);
  const loader = useAppSelector(loading);

  const getVehicleConfiguration = async () => {
    try {
      setLoader1(true);
      const results = await fetchWrapper.get("get-all-consignment-types");
      if (results.isSuccess === true) {
        const activeConsignment = await results.value.filter((data: any) => data.isActive);
        setconsignmentType(activeConsignment);
        return setLoader1(false);
      }
    } catch (error: any) {
      setLoader1(false);
    }
  };

  const getAllTerminal = async () => {
    try {
      setLoader1(true);
      const results = await fetchWrapper.get("terminals_get_all");
      if (results.isSuccess === true) {
        const activeTerminal = await results.value.terminals.filter(
          (data: any) => data.isActive && data.terminalId != 0
        );
        setAllTerminal(activeTerminal);
        setTerminalId(Number(localStorage.getItem("terminalId")));
        return setLoader1(false);
      }
    } catch (error: any) {
      setLoader1(false);
    }
  };

  const onMultiSelectSelection = (selectedList: any) => {
    formik.setFieldValue(
      "consignmentTypes",
      selectedList.map((item: any) => (item.id ? item.id : ""))
    );
  };
  const onMultiSelectRemove = (selectedList: any) => {
    formik.setFieldValue(
      "consignmentTypes",
      selectedList.map((item: any) => (item.id ? item.id : ""))
    );
  };

  useEffect(() => {
    getVehicleConfiguration();
    getAllTerminal();
    dispatch(getRolesListingAction());
  }, []);

  useEffect(() => {
    // if (rows.length) {
    let transformedColumns: any = columns.map((column: any) =>
      column.accessorKey === "action"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <>
                  <NewCommonButton
                    onClick={() => {
                      setIsDirty(true);
                      handleUpdateClick(row.original);
                    }}
                    icon={<EditIcon />}
                    isEdit={true}
                  >
                    Edit
                  </NewCommonButton>

                  <MuiLink
                    to={`/management/assign-permissions/${row.original.id}/${row.original.terminalId}`}
                    component={Link}
                    style={{ textDecoration: "none", marginBottom: "8px" }}
                  >
                    <NewCommonButton icon={<HttpsIcon />} isEdit={false}>
                      Assign Permissions
                    </NewCommonButton>
                  </MuiLink>
                </>
              );
            },
          }
        : column.accessorKey === "consignmentTypes"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <React.Fragment>
                  {row.original?.roleListConsignments.map((data: any) => (
                    <>
                      {data?.consigmentId != 0 && (
                        <Chip
                          key={data?.consigmentId}
                          label={data?.consignmentName}
                          variant="outlined"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                    </>
                  ))}
                </React.Fragment>
              );
            },
          }
        : column.accessorKey === "isActive"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <React.Fragment>
                  <Box>
                    <Tooltip title={row.original?.isActive ? "Yes" : "No"}>
                      <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                        {row.original?.isActive ? <Check /> : <Close />}
                      </Button>
                    </Tooltip>
                  </Box>
                </React.Fragment>
              );
            },
          }
        : column
    );
    if (Number(localStorage.getItem("terminalId")) !== 0) {
      transformedColumns = transformedColumns.filter((x: any) => x.accessorKey !== "terminalName");
    }
    setDisplayColumns(transformedColumns);
  }, []);
  const handleUpdateClick = (params: any) => {
    setTerminalId(params.terminalId);
    setSelectedRecord(params);
    formik.setFieldValue("roleName", params.roleName);
    formik.setFieldValue("id", params.id);
    formik.setFieldValue("isActive", params.isActive);
    formik.setFieldValue("terminalId", params.terminalId);
    if (params?.roleListConsignments) {
      const arr = params?.roleListConsignments.map((data: any) => {
        return { id: data.consigmentId, name: data.consignmentName };
      });

      setSelctedConsignment(arr);
      formik.setFieldValue(
        "consignmentTypes",
        arr.map((item: any) => (item.id ? item.id : ""))
      );
    }
    setisEditMode(true);
  };
  const validationSchema = Yup.object().shape({
    roleName: Yup.string()
      .max(50, "Maximum 50 characters allowed")
      .required("This field is required"),
    terminalId: Yup.string().required("This field is required"),
  });
  const formik = useFormik({
    initialValues: {
      roleName: "",
      isActive: false,
      consignmentTypes: [],
      terminalId:
        Number(localStorage.getItem("terminalId")) !== 0
          ? Number(localStorage.getItem("terminalId"))
          : "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      let res: any;
      if (isEditMode) res = await dispatch(updateUserRoleAction(values));
      else {
        formik.setFieldValue("id", 0);
        res = await dispatch(addUserRoleAction(values));
      }
      if (res.payload) {
        setisEditMode(false);
        setIsDirty(false);
        dispatch(getRolesListingAction());
        actions.setSubmitting(false);
        actions.resetForm();
        setSelectedRecord(null);
        const current = multiselectRef?.current;
        if (current) {
          current?.getUpdated();
        }
      }
    },
  });

  const { setValues } = formik;
  const resetForm = () => {
    setIsDirty(false);
    setValues(formik.initialValues);
    formik.setSubmitting(false);
    setisEditMode(false);
    setSelectedRecord(null);
    const current = multiselectRef?.current;
    if (current) {
      current?.getUpdated();
    }
  };
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleValueChange(e: any) {
    formik.handleChange(e);
    e.target.value ? setIsDirty(true) : setIsDirty(false);
  }

  function isConsinmentTypeExists(arr1: any, arr2: any) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every((obj1: any) => {
      return arr2.find((obj2: any) => obj1.consigmentId == obj2);
    });
  }

  function handleValueChangeTerminal(terId: number) {
    setTerminalId(terId);
    const current = multiselectRef?.current;
    if (current) {
      current?.getUpdated();
    }
    formik.setFieldValue("consignmentTypes", []);
  }

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={ManagementRoute.path} />
      <Backdrop className={classes.backdrop} open={loader || loader1}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetForm()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  disable={
                    selectedRecord
                      ? selectedRecord?.roleName == formik.values.roleName &&
                        selectedRecord?.isActive == formik.values.isActive &&
                        selectedRecord &&
                        isConsinmentTypeExists(
                          selectedRecord?.roleListConsignments,
                          formik.values.consignmentTypes
                        )
                      : false
                  }
                  onClick={() => {
                    formik.submitForm();
                  }}
                >
                  {isEditMode ? "Update" : "Save"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={6} md={6} lg={3}>
                <Box>
                  <TextField
                    className="customTextField"
                    required
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Name"
                    name="roleName"
                    placeholder="Name"
                    disabled={false}
                    value={formik.values.roleName}
                    onChange={handleValueChange}
                    error={formik.touched.roleName && Boolean(formik.errors.roleName)}
                    helperText={formik.touched.roleName && formik.errors.roleName}
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={6} lg={3}>
                <Box>
                  <CommonAutoCompleteField
                    required
                    cssClassName="customTextField"
                    error={formik.touched.terminalId && Boolean(formik.errors.terminalId)}
                    helperText={formik.touched.terminalId && formik.errors.terminalId}
                    label="Terminal"
                    placeholder="Select Terminal"
                    name="terminalId"
                    optionsType={allTerminal}
                    getOptionLabel={(option: any) => option.terminalName || ""}
                    value={
                      allTerminal.find((st: any) => st.terminalId === formik.values.terminalId) ||
                      null
                    }
                    onChange={(option: any) => {
                      formik.setFieldValue("terminalId", option.terminalId);
                      handleValueChange({ target: { value: option.terminalId } });
                      handleValueChangeTerminal(option.terminalId);
                    }}
                    disabled={Number(localStorage.getItem("terminalId")) != 0}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                lg={3}
                // style={{
                //   top: "15px",
                //   position: "relative",
                //   padding: "0 8px",
                // }}
              >
                <Box>
                  <TextField
                    // required
                    className={"customTextField"}
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onKeyDown={(event: any) => {
                      if (event.key !== "Tab") event.preventDefault();
                    }}
                    label="Type of Consignment"
                    error={
                      formik.touched.consignmentTypes && Boolean(formik.errors.consignmentTypes)
                    }
                    helperText={formik.touched.consignmentTypes && formik.errors.consignmentTypes}
                  />
                  <Box
                    className={classes.multiselectConfigFileCompression}
                    style={{
                      bottom:
                        formik.touched.consignmentTypes && Boolean(formik.errors.consignmentTypes)
                          ? "55px"
                          : "35px",
                    }}
                  >
                    <MultiSelect2
                      allValues={consignmentType?.filter(
                        (item: any) => item?.terminalId == terminalId
                      )}
                      selctedItems={selctedConsignment}
                      displayValue={"name"}
                      placeholder="Select Type of Consignment"
                      onSelect={onMultiSelectSelection}
                      onRemove={onMultiSelectRemove}
                      ref={multiselectRef}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={4} md={6} lg={3}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.isActive)}
                      onChange={formik.handleChange}
                      name="isActive"
                      color="primary"
                    />
                  }
                  label="Is Active"
                />
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "15px", marginBottom: "15px" }}>{/* <Divider /> */}</Box>

          <div className="">
            <CommonMaterialGrid
              rows={listRoles}
              columns={displayColumns}
              // loader={loader}
              defaultPerPageRecord={15}
              height={550}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
